<template>
<ItpModal
  :size="size"
  :header="documentTitle"
  :loaded="loaded"
  :noShow="!loaded"
  :modal="modal"
  itp-cname="MCompanyEditor"
  @close="evh_7315092382398562_close($event, {})"
>
  <UcHeader
    :card="!modal"
    :modal="modal"
    :title="documentTitle"
    slot="header"
    v-if="loaded"
    @close="evh_2248226175642056_close($event, {})"
  >
  </UcHeader>
  <UcBody
    :card="!modal"
    :modal="modal"
    v-if="loaded"
  >
    <ItpForm
      :id="formId"
      name="company"
      class="row"
      ref="mainForm"
      @submit="evh_1040167445267876_submit($event, {})"
    >
      <ItpCol>
        <MCompanyEditorFieldset
          :item="editor"
          :formId="formId"
          :target="target"
        >
        </MCompanyEditorFieldset>
      </ItpCol>
    </ItpForm>
  </UcBody>
  <UcFooter
    :card="!modal"
    :modal="modal"
    slot="footer"
    v-if="loaded"
  >
    <ItpButton
      :text="'Save'|pgettext('Button')"
      :disabled="!forms.company || !forms.company.submittable"
      type="submit"
      :form="formId"
      variant="primary"
      icon="fa-save"
      :spinning="actions.save.isRunning"
    >
    </ItpButton>
    <ItpButton
      :text="'Close'|gettext"
      variant="default"
      @click.prevent.stop="evh_1419464017721962_clickPreventStop($event, {})"
    >
    </ItpButton>
  </UcFooter>
  <template
    slot="footer"
    v-if="loaded"
  >
  </template>
</ItpModal>
</template>

<script lang="ts">

import * as _ from 'lodash';
import Big from 'big.js';
import { Vue, Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import {
  addRoute, UserComponentMixin, ComponentValueCache, actions
} from '@integro/core';

@Component()
export default class MCompanyEditor extends mixins(UserComponentMixin) {
  componentMetadata = {
    kind: "modal",
  };

  beforeCreate() {
  }

  getPayload(...args: any[]) {
    const [editor] = args
    console.log(editor)
    return {
      id: editor.id,
      etag: editor.getETAG(),
      ...editor.getChanges({ skipEmbeddedLists: true })
    };
  }

  @Prop({
    type: Object,
  })
  item!: object;

  @Watch('item')
  onItem(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("item")
  }

  @Prop({
    type: String,
  })
  target!: string;

  @Watch('target')
  onTarget(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("target")
  }

  @Prop({
    type: String,
    default: "lg",
  })
  size!: string;

  @Watch('size')
  onSize(newValue: any, oldValue: any) {
    if (_.isEqual(newValue, oldValue)) return;
    this.loadDataThrottled("size")
  }

  formId!: any;

  async $$load_formId() {
    return this.$fn.randomElementId()
  }

  defaultTitle!: any;
  targetConfig!: any;
  editor!: any;

  async $$load_editor() {
    return this.item.editor()
  }

  ux!: any;
  dataMembers = ['formId', 'defaultTitle', 'targetConfig', 'editor', 'ux'];

  data() {
    return {
      ...this.mixinData(),
      actions: this.getActions(),
      ...{
        formId: null,
        defaultTitle: this.$fn.pgettext("Company", "Edit General Information"),
        targetConfig: {
          general: {
            title: this.$fn.pgettext("Company", "Edit general data"),
            fieldsToSubmit: ["*"
              ,
            ]
            ,
          }
          ,
        }
        ,
        editor: null,
        ux: null,
      },
    }
  }

  get document() {
    if (this.loaded) {

      return {
        title: this.target ? this.targetConfig[this.target].title : this.defaultTitle,
      }
    }
    return null;
  }

  async act_7315092382398562_closeModal_3010_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_7315092382398562_closeModal_3010, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
        cancel: true,
      }
      ,
    }
  }

  async evh_7315092382398562_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
  }

  async evh_2248226175642056_close(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
  }

  async act_1040167445267876_closeModal_3016_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1040167445267876_closeModal_3016, alias=undefined
    return {
      result: {
        ok: true,
        value: $event.data,
      }
      ,
    }
  }

  async act_1040167445267876_crud_3014_getActionArgs($event: actions.ActionEvent): Promise<actions.CRUDActionArgs> {
    // parameterResolver name=act_1040167445267876_crud_3014, alias=save
    return {
      objectType: "company",
      op: "upsert",
      data: this.getPayload(this.editor),
    }
  }

  async evh_1040167445267876_submit(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1040167445267876_submit.executeFromDOM(this, event, scope);
  }

  async act_1419464017721962_closeModal_3018_getActionArgs($event: actions.ActionEvent): Promise<actions.CloseModalActionArgs> {
    // parameterResolver name=act_1419464017721962_closeModal_3018, alias=undefined
    return {
      name: this.modalName,
      result: {
        close: true,
      }
      ,
    }
  }

  async evh_1419464017721962_clickPreventStop(event: Event, scope: Dictionary<any>) {
    return await this.actions.evh_1419464017721962_clickPreventStop.executeFromDOM(this, event, scope);
  }

  actions!: {
    act_7315092382398562_closeModal_3010: actions.CloseModalAction;
    evh_7315092382398562_close_3009: actions.EventHandlerImpl;
    evh_7315092382398562_close: actions.EventHandlerGroup;
    act_2248226175642056_closeModal_3012: actions.CloseModalAction;
    evh_2248226175642056_close_3011: actions.EventHandlerImpl;
    evh_2248226175642056_close: actions.EventHandlerGroup;
    act_1040167445267876_closeModal_3016: actions.CloseModalAction;
    evh_1040167445267876_success_3015: actions.EventHandlerImpl;
    act_1040167445267876_crud_3014: actions.CRUDAction;
    evh_1040167445267876_submit_3013: actions.EventHandlerImpl;
    evh_1040167445267876_submit: actions.EventHandlerGroup;
    act_1419464017721962_closeModal_3018: actions.CloseModalAction;
    evh_1419464017721962_clickPreventStop_3017: actions.EventHandlerImpl;
    evh_1419464017721962_clickPreventStop: actions.EventHandlerGroup;
  }

  getActions() {
    const act_7315092382398562_closeModal_3010 = new actions.CloseModalAction(
      {
        actionArgs: this.act_7315092382398562_closeModal_3010_getActionArgs,
        events: [],
      }
    );
    const evh_7315092382398562_close_3009 = new actions.EventHandlerImpl(
      {
        action: act_7315092382398562_closeModal_3010,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_7315092382398562_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_7315092382398562_close_3009],
      }
    );
    const act_2248226175642056_closeModal_3012 = new actions.CloseModalAction(
      {
        events: [],
      }
    );
    const evh_2248226175642056_close_3011 = new actions.EventHandlerImpl(
      {
        action: act_2248226175642056_closeModal_3012,
        event: "close",
        displayName: "closeModal",
      }
    );
    const evh_2248226175642056_close = new actions.EventHandlerGroup(
      {
        handlers: [evh_2248226175642056_close_3011],
      }
    );
    const act_1040167445267876_closeModal_3016 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1040167445267876_closeModal_3016_getActionArgs,
        events: [],
      }
    );
    const evh_1040167445267876_success_3015 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_closeModal_3016,
        event: "success",
        displayName: "closeModal",
      }
    );
    const act_1040167445267876_crud_3014 = new actions.CRUDAction(
      {
        actionArgs: this.act_1040167445267876_crud_3014_getActionArgs,
        displayName: "save",
        events: [evh_1040167445267876_success_3015],
      }
    );
    const evh_1040167445267876_submit_3013 = new actions.EventHandlerImpl(
      {
        action: act_1040167445267876_crud_3014,
        event: "submit",
        displayName: "save",
      }
    );
    const evh_1040167445267876_submit = new actions.EventHandlerGroup(
      {
        handlers: [evh_1040167445267876_submit_3013],
      }
    );
    const act_1419464017721962_closeModal_3018 = new actions.CloseModalAction(
      {
        actionArgs: this.act_1419464017721962_closeModal_3018_getActionArgs,
        events: [],
      }
    );
    const evh_1419464017721962_clickPreventStop_3017 = new actions.EventHandlerImpl(
      {
        action: act_1419464017721962_closeModal_3018,
        event: "click.prevent.stop",
        displayName: "closeModal",
      }
    );
    const evh_1419464017721962_clickPreventStop = new actions.EventHandlerGroup(
      {
        handlers: [evh_1419464017721962_clickPreventStop_3017],
      }
    );
    return {
      act_7315092382398562_closeModal_3010,
      evh_7315092382398562_close_3009,
      evh_7315092382398562_close,
      act_2248226175642056_closeModal_3012,
      evh_2248226175642056_close_3011,
      evh_2248226175642056_close,
      act_1040167445267876_closeModal_3016,
      evh_1040167445267876_success_3015,
      act_1040167445267876_crud_3014,
      evh_1040167445267876_submit_3013,
      evh_1040167445267876_submit,
      act_1419464017721962_closeModal_3018,
      evh_1419464017721962_clickPreventStop_3017,
      evh_1419464017721962_clickPreventStop,
      save: act_1040167445267876_crud_3014,
    }
  }
}

Vue.component("MCompanyEditor", MCompanyEditor);

</script>